export enum SessionState {
  ASMAGENT = 'asmAgent',
  IMPERSONATEUSER = 'impersonateUser',
  IMPERSONATESESSION = 'impersonateSession',
  CURRENTUSER = 'currentUser',
  ANONYMOUS = 'anonymous',
}
